/* eslint-disable import/prefer-default-export */
/* eslint-disable import/no-named-as-default */
// eslint-disable-next-line import/no-named-as-default-member
import Request from './request';

export const apiGetProductDetail = async (id) => {
  return Request.call({
    url: `/product/${id}`,
    method: 'GET',
  });
};

export const apiCreateFolder = async (data) => {
  return Request.call({
    url: `product/folder`,
    method: 'POST',
    data,
  });
};

export const apiCreateTab = async (productId, data) => {
  return Request.call({
    url: `product/${productId}/tab`,
    method: 'POST',
    data,
  });
};

export const apiUpdateTab = (productId, data) => {
  return Request.call({
    url: `product/${productId}/tab`,
    method: 'PUT',
    data,
  });
};

export const apiDeleteTab = (productId, data) => {
  return Request.call({
    url: `product/${productId}/tab`,
    method: 'DELETE',
    data,
  });
};

export const apiCreateFile = (data) => {
  return Request.call({
    url: `product/files `,
    method: 'POST',
    data,
  });
};

export const apiShareFileByEmail = (data) => {
  return Request.call({
    url: '/product/shareFiles/email',
    method: 'POST',
    data,
  });
};

export const apiBulkDownload = (data) => {
  return Request.call({
    url: '/product/download',
    method: 'POST',
    data,
  });
};

export const apiUpdateExpiryDate = (productId, data) => {
  return Request.call({
    url: `/product/${productId}/expirydate`,
    method: 'POST',
    data,
  });
};

export const apiUpdateReminder = (productId, data) => {
  return Request.call({
    url: `/product/${productId}/reminder`,
    method: 'POST',
    data,
  });
};

export const apiDeleteFileFolder = (productId, data) => {
  return Request.call({
    url: `/product/${productId}/delete/files`,
    method: 'POST',
    data,
  });
};

export const apiRenameFolder = (folderId, data) => {
  return Request.call({
    url: `/product/folder/${folderId}`,
    method: 'PATCH',
    data,
  });
};

export const apiRenameFile = (fileId, data) => {
  return Request.call({
    url: `/files/${fileId}/rename`,
    method: 'POST',
    data,
  });
};

export const apiMoveFileFolder = (productId, data) => {
  return Request.call({
    url: `/product/${productId}/files`,
    method: 'PATCH',
    data,
  });
};
